<template>
    <div>
        <b-modal
            id="m-input-titip-jual"
            title="Input Titip Jual"
            size="xl"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <LoadingWidget
                v-if="initStatus != 1"
                :status="initStatus"
                @init="init"
            />
            <div v-else>
                <b-alert v-if="hasActiveVariance" show variant="warning">
                    <i class="fa fa-exclamation-triangle mr-2" />Barang sedang dalam temuan ({{ activeVarianceStatusText }}).
                    Approve dinonaktifkan sampai temuan selesai.
                </b-alert>
                <h5>
                    Informasi Barang
                </h5>

                <hr />

                <b-row>
                    <b-col>
                        <div class="d-flex flex-column mb-2">
                            <strong>Kode Titip Jual</strong>
                            <span>{{ itemData.code }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>No. Faktur</strong>
                            <span>{{ itemData.no_faktur || "-" }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>IMEI / SN</strong>
                            <span>{{ itemData.imei_sn || "-" }}</span>
                        </div>
                        <div class="d-flex flex-column">
                            <strong>Catatan</strong>
                            <span>{{ itemData.note || "-" }}</span>
                        </div>
                    </b-col>
                    <b-col>
                        <div class="d-flex flex-column mb-2">
                            <strong>Nama Barang</strong>
                            <span>{{ itemData.name }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>Jenis Barang</strong>
                            <span>{{ itemData.kind_name }}</span>
                        </div>
                        <div class="d-flex flex-column mb-2">
                            <strong>Harga Barang</strong>
                            <span>{{
                                $helper.formatThousand(itemData.price)
                            }}</span>
                        </div>
                        <div class="d-flex flex-column">
                            <strong>Kelengkapan Barang</strong>
                            <span>{{
                                itemData.is_fullset == 1
                                    ? "Lengkap"
                                    : "Batangan"
                            }}</span>
                        </div>
                    </b-col>
                </b-row>

                <h5 class="mt-3">
                    Form Input Barang
                </h5>

                <hr />

                <b-row class="mt-3">
                    <b-col md="6">
                        <div>
                            <div class="font-weight-bold">Jenis Barang</div>
                            <div id="jenis-barang">
                                <multiselect
                                    v-model="kindId"
                                    :allow-empty="false"
                                    label="name"
                                    track-by="id"
                                    :internal-search="true"
                                    @input="fetchMerkBarang"
                                    placeholder="-- Pilih Salah Satu --"
                                    :options="kinds"
                                />
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">Merk Barang</div>
                            <div id="merk-barang">
                                <multiselect
                                    :disabled="fetch || !kindId"
                                    v-model="brandId"
                                    :allow-empty="false"
                                    label="name"
                                    track-by="id"
                                    :internal-search="true"
                                    @input="fetchTipeBarang"
                                    placeholder="-- Pilih Salah Satu --"
                                    :options="brands"
                                />
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">Tipe Barang</div>
                            <div id="tipe-barang">
                                <multiselect
                                    :disabled="fetch || !brandId"
                                    v-model="typeId"
                                    :allow-empty="false"
                                    label="name"
                                    track-by="id"
                                    :internal-search="true"
                                    @input="fetchTahunBarang"
                                    placeholder="-- Pilih Salah Satu --"
                                    :options="types"
                                />
                            </div>
                        </div>
                        <div v-if="hasYear">
                            <div class="font-weight-bold mt-3">
                                Tahun / Generasi Barang
                            </div>
                            <div id="tahun-barang">
                                <multiselect
                                    :disabled="fetch || !typeId"
                                    v-model="yearId"
                                    :allow-empty="false"
                                    label="year"
                                    track-by="id"
                                    :internal-search="true"
                                    placeholder="-- Pilih Salah Satu --"
                                    :options="years"
                                />
                            </div>
                            <!-- <b-form-select :disabled="fetch || !typeId" v-model="yearId" text-field="year" value-field="id"
                        :options="years" /> -->
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">Description</div>
                            <b-form-textarea
                                id="description"
                                v-model="input.description"
                            />
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div>
                            <div class="font-weight-bold">
                                No. Faktur Original
                            </div>
                            <b-input
                                placeholder="Masukkan No. Faktur Original"
                                id="no-faktur-original"
                                v-model="input.noFakturOriginal"
                            />
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">IMEI / SN</div>
                            <b-input
                                id="imei-sn"
                                v-model="input.imeiSn"
                                placeholder="Masukkan IMEI / SN"
                            />
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">Password</div>
                            <b-input
                                id="password"
                                v-model="input.password"
                                placeholder="Masukkan Password"
                            />
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col md="3">
                        <b-form-group label="Grade Barang">
                            <b-form-select
                                id="grade-barang"
                                v-model="input.grade"
                                :options="optGrade"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Kelengkapan Barang">
                            <b-form-select
                                id="kelengkapan-barang"
                                v-model="input.isBatangan"
                                :options="optBatangan"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Spek Barang">
                            <b-form-select
                                id="spek-barang"
                                v-model="input.spec"
                                :options="optSpec"
                                text-field="name"
                                value-field="id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Warna Barang">
                            <b-form-select
                                id="warna-barang"
                                v-model="input.color"
                                :options="optColor"
                                text-field="name"
                                value-field="id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Modal">
                            <b-input-group prepend="Rp.">
                                <b-form-input
                                    id="modal"
                                    disabled
                                    v-model="input.capital"
                                    maxlength="50"
                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                    @input="sanitizeCapital"
                                />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="input.grade == 'X'">
                    <b-col md="12">
                        <b-form-group
                            :label="'Penyesuaian Harga Grade ' + input.grade"
                            description="Gunakan tanda negatif didepan untuk pengurangan harga (Bila positif, maka dianggap penambahan harga)"
                        >
                            <b-input-group prepend="Rp.">
                                <b-input
                                    id="penyesuaian-harga-grade"
                                    v-model="input.adjGrade"
                                    @input="sanitizeAdjGrade"
                                />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <div style="display:flex; justify-content: end;">
                            <b-button
                                id="submit-barang"
                                variant="success"
                                :disabled="isSubmitting || hasActiveVariance"
                                @click="approve"
                            >
                                {{
                                    isSubmitting
                                        ? "Menyimpan..."
                                        : "Submit Barang"
                                }}
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal
            id="m-barcode"
            title="Cetak Barcode"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header-close
        >
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak
            dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe
                id="barcode-iframe"
                :src="getBarcodeLink()"
                height="300px"
                width="100%"
            />
            <div class="mt-4">
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button
                            id="finish-approval"
                            variant="primary"
                            @click="finishApproval"
                        >
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { getVarianceStatusBadge } from "@/shared/inventory-variance";

export default {
    name: "modal-input-titip-jual",
    props: {
        item: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            itemData: {},

            initStatus: 0,
            isSubmitting: false,
            input: {
                year: null,
                isHandphone: null,
                isBatangan: 0, // Default Lengkap
                imeiSn: null,
                grade: "A", // Default A
                password: null,
                color: null,
                capital: null,
                spec: null, // Default Resmi
                priceAtPawn: null,
                adjGrade: null,
                missingAcc: [],
                nonOriAcc: [],
                description: null,
                noFakturOriginal: null,
                basePrice: null
            },

            optGrade: ["S", "A", "B", "C", "D", "E", "X"],
            optSpec: [],
            optWarehouse: [],
            optBatangan: [
                { value: 0, text: "Lengkap" },
                { value: 1, text: "Batangan" }
            ],
            optColor: [],
            optAccessories: [],
            optYear: [],
            kinds: [],
            brands: [],
            types: [],
            years: [],
            kindId: null,
            brandId: null,
            typeId: null,
            yearId: null,
            fetch: false,

            barcodeLinkDamage: null,
            barcodeLink: null,
        };
    },
    methods: {
        async init() {
            this.optAccessories = [];

            this.initStatus = 0;

            await Promise.all([
                this.fetchJenisBarang(),
                this.fetchColor(),
                this.getItem()
            ]);
            this.initStatus = 1;
        },

        async getItem() {
            if (!this.item) {
                this.$helper.toastError(this, "Item tidak ditemukan");
                return;
            }
            await this.$axios
                .get(
                    "consignment/item/detail?code=" +
                        this.item.code +
                        "&batch_id=" +
                        this.item.batch_id
                )
                .then(res => {
                    this.itemData = res.data.data;

                    this.input.imeiSn = this.itemData.imei_sn;
                    this.input.noFakturOriginal = this.itemData.no_faktur;
                    this.input.capital = this.$helper.formatThousand(
                        this.itemData.capital
                    );
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        async fetchAdjustment() {
            await this.$axios
                .get("category/selection?item_kind_id=" + this.kindId.id)
                .then(res => {
                    this.optCategory = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        };
                    });
                });
        },

        async fetchJenisBarang() {
            this.brandId = null;
            this.typeId = null;
            this.yearId = null;
            this.input.missingAcc = [];
            this.input.nonOriAcc = [];

            this.fetch = true;
            // only fetch data whose category is electornic
            await this.$axios
                .get("master/kinds?category=ELEK")
                .then(res => {
                    this.kinds = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchMerkBarang() {
            this.brandId = null;
            this.typeId = null;
            this.yearId = null;
            this.input.missingAcc = [];
            this.input.nonOriAcc = [];

            this.fetch = true;
            await this.$axios
                .get(`master/brands/${this.kindId.id}`)
                .then(res => {
                    this.brands = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });

            await this.fetchAccessories();
            await this.fetchAdjustment();
        },

        async fetchTipeBarang() {
            this.fetch = true;

            this.typeId = null;
            this.yearId = null;
            this.input.missingAcc = [];
            this.input.nonOriAcc = [];

            await this.$axios
                .get(`master/types/${this.brandId.id}`)
                .then(res => {
                    this.types = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchTahunBarang(e) {
            this.input.basePrice = e.base_price;

            this.yearId = null;

            this.fetch = true;
            await this.$axios
                .get(`master/years/${this.typeId.id}`)
                .then(res => {
                    this.years = res.data.data;
                });

            await this.$axios
                .get(`master/type-price/${this.typeId.id}`)
                .then(res => {
                    this.optSpec = res.data.data;
                });

            this.fetch = false;
        },

        async fetchSpec() {
            this.fetch = true;
            await this.$axios
                .get("master/spec/selection")
                .then(res => {
                    this.optSpec = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchAccessories() {
            this.fetch = true;
            await this.$axios
                .get(`master/accessory-option?filterKind=${this.kindId.id}`)
                .then(res => {
                    this.optAccessories = res.data.data.items;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchColor() {
            this.fetch = true;
            await this.$axios
                .get("master/color/selection")
                .then(res => {
                    this.optColor = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async approve() {
            let isConfirmed = confirm(
                "Apakah Anda yakin akan mensetujui barang ini?"
            );

            if (isConfirmed) {
                if (
                    this.input.capital == null ||
                    this.input.capital == ""
                ) {
                    this.$helper.toastError(this, "Modal tidak boleh kosong");
                    return;
                }

                if (
                    this.input.color == null ||
                    this.input.color == "" ||
                    this.input.color == 0
                ) {
                    this.$helper.toastError(this, "Warna tidak boleh kosong");
                    return;
                }

                const payload = {
                    consignment_code: this.itemData.code,
                    batch_id: this.itemData.batch_id,
                    type_id: this.typeId ? this.typeId.id : null,
                    spec_id: this.input.spec,
                    grade: this.input.grade,
                    adj_grade: this.input.adjGrade
                        ? this.input.adjGrade
                        : null,
                    year: this.yearId ? this.yearId.year : null,
                    is_batangan: this.input.isBatangan,
                    imei_sn: this.input.imeiSn,
                    password: this.input.password,
                    capital: this.$helper.toNumber(this.input.capital),
                    description: this.input.description,
                    color_id: this.input.color,
                    no_faktur_original: this.input.noFakturOriginal
                };

                this.isSubmitting = true;
                this.$axios
                    .post("consignment/approve", payload)
                    .then(res => {
                        this.$bvModal.hide("m-input-titip-jual");
                        this.$emit("refresh");
                        this.clearInput();

                        this.barcodeLink = res.data.data.link;
                        this.barcodeLinkDamage = res.data.data.linkDamage;
                        this.$bvModal.show("m-barcode");
                    })
                    .catch(error => {
                        this.$helper.parseError(this, error);
                    })
                    .finally(() => (this.isSubmitting = false));
            }
        },

        clearInput() {
            this.input = {
                year: null,
                isHandphone: null,
                isBatangan: null,
                imeiSn: null,
                grade: null,
                password: null,
                color: null,
                capital: null,
                priceAtPawn: null,
                adjGrade: null,
                missingAcc: [],
                nonOriAcc: []
            };

            this.kindId = null;
            this.brandId = null;
            this.typeId = null;
            this.yearId = null;
            this.adjustments = [];
        },

        getBarcodeLink() {
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`;
        },

        finishApproval() {
            this.$bvModal.hide("m-barcode");
            this.$emit("approved");
        },

        sanitizeCapital() {
            let cleaned = String(this.input.capital).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.input.capital = res;
        },

        sanitizeAdjGrade() {
            let cleaned = String(this.input.adjGrade).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.input.adjGrade = res;
        },



    },
    mounted() {
        // this.init()
    },
    computed: {
        hasYear() {
            if (!this.typeId) return null;
            return this.typeId.has_year;
        },
        hasActiveVariance() {
            return !!this.itemData.active_variance_id;
        },
        activeVarianceStatusText() {
            return getVarianceStatusBadge(this.itemData.active_variance_status).text;
        }
    },
    watch: {
        item(newItem) {
            if (!newItem) {
                return;
            }
            this.init();
        },
    }
};
</script>
